// Transient top-of-screen banners. "Smart": an informational toast (no action)
// auto-dismisses; an actionable one (has an action button — "Select a Page",
// "Reconnect") is sticky and stays until the user acts or closes it. Auto-dismiss
// timing is handled by the pusher (App.tsx pushToast), not here.

export type ToastKind = "ok" | "err" | "warn" | "info";

export interface Toast {
  id: string;
  kind: ToastKind;
  text: string;
  /** When present, the toast is actionable: it renders a button and (by default)
   * is sticky. */
  action?: { label: string; onClick: () => void };
  /** Override the auto-dismiss default (actionable = stick, info = fade). An
   * Undo toast, for instance, has an action yet should still fade. */
  sticky?: boolean;
}

export function Toasts({
  toasts,
  onDismiss,
}: {
  toasts: Toast[];
  onDismiss: (id: string) => void;
}) {
  if (toasts.length === 0) return null;
  return (
    <div className="toasts" role="region" aria-label="Notifications">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast--${t.kind}`} role="status">
          <span className="toast-text">{t.text}</span>
          {t.action && (
            <button
              type="button"
              className="toast-action"
              onClick={() => {
                t.action!.onClick();
                onDismiss(t.id);
              }}
            >
              {t.action.label}
            </button>
          )}
          <button
            type="button"
            className="toast-close"
            aria-label="Dismiss"
            onClick={() => onDismiss(t.id)}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
